import React from 'react';

import { AutoshipmentLogoLockup } from '@zooplus/ui-components';

import { useSiteContext } from '@zooplus/commons-lang';
// @ts-ignore
import {AutoshipmentLogoSizes} from "@zooplus/ui-components/dist/es/src/components/Autoshipment/types";

interface AutoshipLogoProps {
  className?: string;
  logoSize: AutoshipmentLogoSizes;
}
export const AutoshipLogo: React.FC<AutoshipLogoProps> = (props: AutoshipLogoProps) => {
  const { site, locale } = useSiteContext();
  return (
    <div className={props.className}>
      <AutoshipmentLogoLockup size={props.logoSize} locale={locale} realm={site.realm} />
    </div>
  );
};
